var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSendingMessage = function SvgSendingMessage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97655 24.4722L7.36255 18.3262L37.7565 24.9822L7.31055 31.6922L8.97455 25.5002L9.11255 24.9862L8.97655 24.4722Z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1681 22.2182L4.89368 4.16744C4.18419 3.86198 3.3621 3.99379 2.78366 4.50575C2.20522 5.0177 1.9745 5.81768 2.19148 6.55904L7.04268 24.9804L2.06768 43.495C1.87046 44.233 2.11212 45.0189 2.68995 45.5185C3.26779 46.0182 4.08027 46.1439 4.78208 45.8422L46.1681 27.744C47.278 27.2745 47.9992 26.1863 47.9992 24.9811C47.9992 23.776 47.278 22.6878 46.1681 22.2182ZM8.97674 24.4717L7.36214 18.3261L37.7569 24.9829L7.31054 31.6919L8.97434 25.5005L9.11234 24.9869L8.97674 24.4717ZM4.00002 44.0138L45.3668 25.9114C45.7532 25.7657 46.0066 25.3931 46 24.9802C46.0087 24.576 45.765 24.209 45.389 24.0602L4.12982 6.01379L6.79382 16.1538L42.6338 24.0038C43.0923 24.1047 43.4188 24.511 43.4188 24.9804C43.4188 25.4498 43.0923 25.856 42.6338 25.957L6.72642 33.8682L4.00002 44.0138Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSendingMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sending-message.f72d3a65477056f5b9d6694fd709872c.svg";